export function mobileMenuToggle() {
	document.addEventListener('click', function (e) {
		if (!e.target.matches('.mobile-menu-toggle')) {
			return;
		}
		const header = document.querySelector('.header');

		if (header.classList.contains('open')) { 
			header.classList.remove('open');
		} else {
			header.classList.add('open');
		}
	});
}
